import React, { useState } from "react";
import { User, Mail, Phone, Lock } from "lucide-react";
import { useSelector } from "react-redux";

export default function ProfilePage() {
  const [showPassword, setShowPassword] = useState(false);
  const { user } = useSelector((state) => state.user);
  console.log("USER-->", user);
  const [name, setName] = useState("");

  return (
    <div className="p-4 bg-gray-100  w-full">
      {/* Page Title */}
      <h1 className="text-2xl font-bold text-gray-800 mb-4">
        Profile Settings
      </h1>

      <div className="flex gap-6 items-start">
        {/* LEFT PROFILE CARD */}
        <div className="w-80 bg-white rounded-xl shadow-md border border-gray-100 p-6 text-center">
          <div className="w-24 h-24 mx-auto rounded-full bg-blue-100 flex items-center justify-center text-blue-600 text-3xl font-bold">
            {user?.name?.split("")?.[0]}
          </div>

          <h2 className="mt-4 text-lg font-semibold text-gray-800">
            {user?.name}
          </h2>

          <p className="text-sm text-gray-500">{user?.email}</p>
          {/* 
          <button className="mt-4 text-sm text-blue-600 hover:underline">
            Change Photo
          </button> */}
        </div>

        {/* RIGHT CONTENT */}
        <div className="flex-1 flex flex-col gap-6">
          {/* PROFILE INFO CARD */}
          <div className="bg-white rounded-xl shadow-md border border-gray-100 p-6">
            <h2 className="text-lg font-semibold mb-4 text-gray-800">
              Profile Information
            </h2>

            <div className="grid md:grid-cols-2 gap-4">
              {/* NAME */}
              <div>
                <label className="text-sm text-gray-600">Full Name</label>

                <div className="flex items-center border rounded-lg px-3 py-2 mt-1 bg-gray-50">
                  <User size={18} className="text-gray-400 mr-2" />
                  <input
                    value={user?.name}
                    type="text"
                    defaultValue="Admin Manager"
                    className="bg-transparent outline-none w-full"
                  />
                </div>
              </div>

              {/* EMAIL */}
              <div>
                <label className="text-sm text-gray-600">Email</label>

                <div className="flex items-center border rounded-lg px-3 py-2 mt-1 bg-gray-50">
                  <Mail size={18} className="text-gray-400 mr-2" />
                  <input
                    value={user?.email}
                    type="email"
                    defaultValue="admin@odishaparcel.com"
                    className="bg-transparent outline-none w-full"
                  />
                </div>
              </div>

              {/* PHONE */}
              {/* <div>
                <label className="text-sm text-gray-600">Phone</label>

                <div className="flex items-center border rounded-lg px-3 py-2 mt-1 bg-gray-50">
                  <Phone size={18} className="text-gray-400 mr-2" />
                  <input
                    type="text"
                    placeholder="+91 9876543210"
                    className="bg-transparent outline-none w-full"
                  />
                </div>
              </div> */}
            </div>
            <div className="flex justify-end">
              <button className="mt-5 bg-blue-600 text-white px-5 py-2 rounded-lg text-sm hover:bg-blue-700 transition">
                Save Changes
              </button>
            </div>
          </div>

          {/* SECURITY CARD */}
          <div className="bg-white rounded-xl shadow-md border border-gray-100 p-6">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-semibold text-gray-800">Security</h2>

              <button
                onClick={() => setShowPassword(!showPassword)}
                className="text-sm text-blue-600 hover:underline"
              >
                Change Password
              </button>
            </div>

            {showPassword && (
              <div className="space-y-4">
                {/* CURRENT PASSWORD */}
                <div>
                  <label className="text-sm text-gray-600">
                    Current Password
                  </label>

                  <div className="flex items-center border rounded-lg px-3 py-2 mt-1 bg-gray-50">
                    <Lock size={18} className="text-gray-400 mr-2" />
                    <input
                      type="password"
                      className="bg-transparent outline-none w-full"
                    />
                  </div>
                </div>

                {/* NEW PASSWORD */}
                <div>
                  <label className="text-sm text-gray-600">New Password</label>

                  <div className="flex items-center border rounded-lg px-3 py-2 mt-1 bg-gray-50">
                    <Lock size={18} className="text-gray-400 mr-2" />
                    <input
                      type="password"
                      className="bg-transparent outline-none w-full"
                    />
                  </div>
                </div>

                {/* CONFIRM PASSWORD */}
                <div>
                  <label className="text-sm text-gray-600">
                    Confirm Password
                  </label>

                  <div className="flex items-center border rounded-lg px-3 py-2 mt-1 bg-gray-50">
                    <Lock size={18} className="text-gray-400 mr-2" />
                    <input
                      type="password"
                      className="bg-transparent outline-none w-full"
                    />
                  </div>
                </div>
                <div className="flex justify-end">
                  <button className="bg-blue-600  text-white px-5 py-2 rounded-lg text-sm hover:bg-blue-700 transition">
                    Update Password
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
